/*
 * Copyright Huesik (c) 2019.
 */

const collages = [
  {lat: 35.269806, lng: 128.872556, name: '가야대학교'},
  {lat: 37.45125, lng: 127.129278, name: '가천대학교'},
  {lat: 37.5859, lng: 127.00433, name: '가톨릭대학교'},
  {lat: 37.567361, lng: 126.962417, name: '감리교신학대학교'},
  {lat: 37.275948, lng: 127.13292, name: '강남대학교'},
  {lat: 37.768778, lng: 128.870139, name: '강릉원주대학교'},
  {lat: 37.86944444, lng: 127.74416667, name: '강원대학교'},
  {lat: 37.54194444, lng: 127.07638889, name: '건국대학교'},
  {lat: 37.54075, lng: 127.079333, name: '건국대학교 글로컬캠퍼스'},
  {lat: 36.1822, lng: 127.112, name: '건양대학교'},
  {lat: 37.301217, lng: 127.034595, name: '경기대학교'},
  {lat: 35.180361, lng: 128.553389, name: '경남대학교'},
  {lat: 35.18058333, lng: 128.09397222, name: '경남과학기술대학교'},
  {lat: 38.250857, lng: 128.55549, name: '경동대학교'},
  {lat: 35.891388888889, lng: 128.61055555556, name: '경북대학교'},
  {lat: 35.1541, lng: 128.098, name: '경상대학교'},
  {lat: 35.13977778, lng: 129.0985, name: '경성대학교'},
  {lat: 36.169444444444, lng: 128.46788888889, name: '경운대학교'},
  {lat: 37.53819444, lng: 126.71625, name: '경인교육대학교'},
  {lat: 35.9084, lng: 128.801, name: '경일대학교'},
  {lat: 35.829833, lng: 129.161972, name: '경주대학교'},
  {lat: 36.749029, lng: 126.956592, name: '경찰대학'},
  {lat: 37.5967, lng: 127.052, name: '경희대학교'},
  {lat: 35.8574, lng: 128.4834, name: '계명대학교'},
  {lat: 37.589166666667, lng: 127.0325, name: '고려대학교'},
  {lat: 36.6107, lng: 127.2879, name: '고려대학교 세종캠퍼스'},
  {lat: 35.07961111, lng: 129.063, name: '고신대학교'},
  {lat: 36.469, lng: 127.14, name: '공주대학교'},
  {lat: 36.444, lng: 127.119, name: '공주교육대학교'},
  {lat: 37.7364444, lng: 128.871567, name: '관동대학교'},
  {lat: 35.216027777778, lng: 126.88541666667, name: '광신대학교'},
  {lat: 37.62, lng: 127.0575, name: '광운대학교'},
  {lat: 35.10633333, lng: 126.89513889, name: '광주대학교'},
  {lat: 35.01605606, lng: 126.86463928, name: '광주가톨릭대학교'},
  {lat: 35.22652778, lng: 126.84, name: '광주과학기술원'},
  {lat: 35.165, lng: 126.926, name: '광주교육대학교'},
  {lat: 35.163694, lng: 126.7975, name: '광주여자대학교'},
  {lat: 36.401451, lng: 127.349674, name: '국군간호사관학교'},
  {lat: 37.6110733579974, lng: 126.99732108498152, name: '국민대학교'},
  {lat: 35.945278, lng: 126.682167, name: '군산대학교'},
  {lat: 37.127472, lng: 127.643333, name: '극동대학교'},
  {lat: 36.30538889, lng: 127.19516667, name: '금강대학교'},
  {lat: 36.144417, lng: 128.393278, name: '금오공과대학교'},
  {lat: 36.13994444, lng: 128.08180556, name: '김천대학교'},
  {lat: 36.79513889, lng: 127.119, name: '나사렛대학교'},
  {lat: 35.207167, lng: 126.841222, name: '남부대학교'},
  {lat: 36.90794167, lng: 127.1431472, name: '남서울대학교'},
  {lat: 37.321944444444, lng: 127.12611111111, name: '단국대학교'},
  {lat: 36.38, lng: 129.403, name: '대구대학교'},
  {lat: 35.91219, lng: 128.80775, name: '대구가톨릭대학교'},
  {lat: 35.70527778, lng: 128.45711111, name: '대구경북과학기술원'},
  {lat: 35.853055555556, lng: 128.589, name: '대구교육대학교'},
  {lat: 36.03291667, lng: 128.51019444, name: '대구예술대학교'},
  {lat: 35.796, lng: 128.775, name: '대구한의대학교'},
  {lat: 35.804221, lng: 128.744307, name: '대신대학교'},
  {lat: 36.336, lng: 127.46, name: '대전대학교'},
  {lat: 36.654905, lng: 127.19786, name: '대전가톨릭대학교'},
  {lat: 37.6509, lng: 127.017, name: '덕성여자대학교'},
  {lat: 37.558602, lng: 127.000167, name: '동국대학교'},
  {lat: 37.60633333, lng: 127.04180556, name: '동덕여자대학교'},
  {lat: 35.1794, lng: 129.076, name: '동서대학교'},
  {lat: 35.04969444, lng: 126.71772222, name: '동신대학교'},
  {lat: 35.11586111, lng: 128.96725, name: '동아대학교'},
  {lat: 36.88319444, lng: 128.53377778, name: '동양대학교'},
  {lat: 35.13944444, lng: 129.03336111, name: '동의대학교'},
  {lat: 37.26527786, lng: 127.11316681, name: '루터대학교'},
  {lat: 37.58083333, lng: 126.92388889, name: '명지대학교'},
  {lat: 36.32608333, lng: 127.33861111, name: '목원대학교'},
  {lat: 34.910194444444, lng: 126.43619444444, name: '목포대학교'},
  {lat: 34.82680556, lng: 126.41919444, name: '목포가톨릭대학교'},
  {lat: 34.791805555556, lng: 126.36511111111, name: '목포해양대학교'},
  {lat: 36.32061111, lng: 127.36616667, name: '배재대학교'},
  {lat: 36.84021, lng: 127.18322, name: '백석대학교'},
  {lat: 35.13416667, lng: 129.10361111, name: '부경대학교'},
  {lat: 35.23398, lng: 129.07931, name: '부산대학교'},
  {lat: 35.244888888889, lng: 129.09720277778, name: '부산가톨릭대학교'},
  {lat: 35.19584, lng: 129.07505, name: '부산교육대학교'},
  {lat: 35.12451, lng: 129.08283, name: '부산외국어대학교'},
  {lat: 35.25633, lng: 128.8609, name: '부산장신대학교'},
  {lat: 37.6434, lng: 127.106, name: '삼육대학교'},
  {lat: 37.589265, lng: 127.064543, name: '삼육보건대학교'},
  {lat: 37.602606, lng: 126.955262, name: '상명대학교'},
  {lat: 37.369944444444, lng: 127.92861111111, name: '상지대학교'},
  {lat: 37.551111111111, lng: 126.94111111111, name: '서강대학교'},
  {lat: 37.615, lng: 127.013, name: '서경대학교'},
  {lat: 37.46, lng: 126.95, name: '서울대학교'},
  {lat: 37.63166667, lng: 127.07861111, name: '서울과학기술대학교'},
  {lat: 37.49, lng: 127.01638889, name: '서울교육대학교'},
  {lat: 37.583325, lng: 127.05838611, name: '서울시립대학교'},
  {lat: 37.47941667, lng: 126.789, name: '서울신학대학교'},
  {lat: 37.6278582278924, lng: 127.091256293837, name: '서울여자대학교'},
  {lat: 37.409607, lng: 127.246308, name: '서울장신대학교'},
  {lat: 37.496541, lng: 126.851219, name: '서울한영대학교'},
  {lat: 36.62513889, lng: 127.48216667, name: '서원대학교'},
  {lat: 36.79757, lng: 127.0746, name: '선문대학교'},
  {lat: 37.379972, lng: 126.926778, name: '성결대학교'},
  {lat: 37.48744444, lng: 126.82575, name: '성공회대학교'},
  {lat: 37.587222222222, lng: 126.99416666667, name: '성균관대학교'},
  {lat: 37.59130556, lng: 127.02213889, name: '성신여자대학교'},
  {lat: 37.178162, lng: 128.195403, name: '세명대학교'},
  {lat: 37.550833, lng: 127.073889, name: '세종대학교'},
  {lat: 34.753611111111, lng: 126.48444444444, name: '세한대학교'},
  {lat: 35.108957, lng: 126.874363, name: '송원대학교'},
  {lat: 37.208972222222, lng: 126.97638888889, name: '수원대학교'},
  {lat: 37.193859, lng: 126.934163, name: '수원가톨릭대학교'},
  {lat: 37.545419, lng: 126.964649, name: '숙명여자대학교'},
  {lat: 34.9695, lng: 127.48019444444, name: '순천대학교'},
  {lat: 36.77077, lng: 126.931604, name: '순천향대학교'},
  {lat: 37.496295, lng: 126.95627, name: '숭실대학교'},
  {lat: 37.20263889, lng: 126.83944444, name: '신경대학교'},
  {lat: 35.1675, lng: 128.9967, name: '신라대학교'},
  {lat: 37.511138888889, lng: 127.42825, name: '아세아연합신학대학교'},
  {lat: 37.282913, lng: 127.04607, name: '아주대학교'},
  {lat: 36.54157, lng: 128.79642, name: '안동대학교'},
  {lat: 37.39166667, lng: 126.91972222, name: '안양대학교'},
  {lat: 37.564541, lng: 126.939155, name: '연세대학교'},
  {lat: 37.279416666667, lng: 127.9015, name: '연세대학교 원주캠퍼스'},
  {lat: 35.834166666667, lng: 128.75805555556, name: '영남대학교'},
  {lat: 35.88091667, lng: 128.81797222, name: '영남신학대학교'},
  {lat: 35.42877778, lng: 129.14594444, name: '영산대학교'},
  {lat: 35.325916666667, lng: 126.44080555556, name: '영산선학대학교'},
  {lat: 35.815583333333, lng: 127.13458333333, name: '예수대학교'},
  {lat: 35.647151, lng: 127.270506, name: '예원예술대학교'},
  {lat: 37.227, lng: 127.168, name: '용인대학교'},
  {lat: 35.91263889, lng: 127.06669444, name: '우석대학교'},
  {lat: 36.338, lng: 127.446, name: '우송대학교'},
  {lat: 35.542773, lng: 129.256725, name: '울산대학교'},
  {lat: 35.573, lng: 129.19, name: '울산과학기술원'},
  {lat: 35.969389, lng: 126.957333, name: '원광대학교'},
  {lat: 36.01277778, lng: 129.28311111, name: '위덕대학교'},
  {lat: 36.19580556, lng: 127.7995, name: '유원대학교'},
  {lat: 36.333338, lng: 127.404904, name: '을지대학교'},
  {lat: 37.56186667, lng: 126.94683333, name: '이화여자대학교'},
  {lat: 35.248611111111, lng: 128.9025, name: '인제대학교'},
  {lat: 37.37561389, lng: 126.63331111, name: '인천대학교'},
  {lat: 37.657571, lng: 126.447042, name: '인천가톨릭대학교'},
  {lat: 37.44944444, lng: 126.65444444, name: '인하대학교'},
  {lat: 37.550472222222, lng: 127.10347222222, name: '장로회신학대학교'},
  {lat: 35.176388888889, lng: 126.90805555556, name: '전남대학교'},
  {lat: 35.84682, lng: 127.12935, name: '전북대학교'},
  {lat: 35.81308333, lng: 127.08961111, name: '전주대학교'},
  {lat: 35.808312, lng: 127.155118, name: '전주교육대학교'},
  {lat: 33.455972222222, lng: 126.5619, name: '제주대학교'},
  {lat: 33.441429, lng: 126.569985, name: '제주국제대학교'},
  {lat: 35.142222222222, lng: 126.93305555556, name: '조선대학교'},
  {lat: 36.192083333333, lng: 127.44852777778, name: '중부대학교'},
  {lat: 37.50489, lng: 126.95503, name: '중앙대학교'},
  {lat: 37.604932, lng: 126.70603, name: '중앙승가대학교'},
  {lat: 36.819555555556, lng: 127.79925, name: '중원대학교'},
  {lat: 35.1864, lng: 128.06711, name: '진주교육대학교'},
  {lat: 37.856722222222, lng: 127.13780555556, name: '차의과학대학교'},
  {lat: 35.24422, lng: 128.5996, name: '창신대학교'},
  {lat: 35.24558, lng: 128.69192, name: '창원대학교'},
  {lat: 36.58063, lng: 126.66125, name: '청운대학교'},
  {lat: 36.61611, lng: 127.48463, name: '청주교육대학교'},
  {lat: 36.65265, lng: 127.49539, name: '청주대학교'},
  {lat: 34.977777777778, lng: 126.47277777778, name: '초당대학교'},
  {lat: 37.488, lng: 126.966, name: '총신대학교'},
  {lat: 37.56242, lng: 126.95339, name: '추계예술대학교'},
  {lat: 37.85961, lng: 127.74879, name: '춘천교육대학교'},
  {lat: 36.368888888889, lng: 127.34611111111, name: '충남대학교'},
  {lat: 36.62901111, lng: 127.45709167, name: '충북대학교'},
  {lat: 36.38505556, lng: 127.32683333, name: '침례신학대학교'},
  {lat: 37.305, lng: 127.1287, name: '칼빈대학교'},
  {lat: 37.548361111111, lng: 126.85477777778, name: '강서대학교'},
  {lat: 36.995, lng: 127.133, name: '평택대학교'},
  {lat: 36.010883333333, lng: 129.32266944444, name: '포항공과대학교'},
  {lat: 37.011638888889, lng: 127.26422222222, name: '한경대학교'},
  {lat: 36.372, lng: 127.363, name: '한국과학기술원'},
  {lat: 36.608983, lng: 127.36064, name: '한국교원대학교'},
  {lat: 36.96976, lng: 127.87133, name: '한국교통대학교'},
  {lat: 35.173142, lng: 128.202639, name: '한국국제대학교'},
  {lat: 36.7637, lng: 127.282, name: '한국기술교육대학교'},
  {lat: 37.579027777778, lng: 127.00283333333, name: '한국방송통신대학교'},
  {lat: 37.3404, lng: 126.733, name: '한국산업기술대학교'},
  {lat: 37.648694444444, lng: 127.06419444444, name: '한국성서대학교'},
  {lat: 37.6055, lng: 127.05605556, name: '한국예술종합학교'},
  {lat: 37.597215, lng: 127.058537, name: '한국외국어대학교'},
  {lat: 36.308, lng: 126.897, name: '한국전통문화대학교'},
  {lat: 37.51963889, lng: 127.13097222, name: '한국체육대학교'},
  {lat: 37.59936111, lng: 126.86511111, name: '한국항공대학교'},
  {lat: 35.074472, lng: 129.087489, name: '한국해양대학교'},
  {lat: 36.354472, lng: 127.421167, name: '한남대학교'},
  {lat: 36.103055555556, lng: 129.38844444444, name: '한동대학교'},
  {lat: 37.30283333, lng: 127.90811111, name: '한라대학교'},
  {lat: 34.95638889, lng: 127.565, name: '한려대학교'},
  {lat: 37.8866303, lng: 127.7353948, name: '한림대학교'},
  {lat: 36.350777777778, lng: 127.30061111111, name: '한밭대학교'},
  {lat: 36.6905, lng: 126.583861, name: '한서대학교'},
  {lat: 37.581722222222, lng: 127.01027777778, name: '한성대학교'},
  {lat: 37.342428, lng: 126.953838, name: '한세대학교'},
  {lat: 37.32694444, lng: 127.04138889, name: '한신대학교'},
  {lat: 37.55638889, lng: 127.04444444, name: '한양대학교'},
  {lat: 35.763699, lng: 127.206367, name: '한일장신대학교'},
  {lat: 37.2132, lng: 126.952808, name: '협성대학교'},
  {lat: 35.15077778, lng: 126.76847222, name: '호남대학교'},
  {lat: 35.140493, lng: 126.911202, name: '호남신학대학교'},
  {lat: 36.827407, lng: 127.183421, name: '호서대학교'},
  {lat: 36.96625, lng: 126.86480556, name: '호원대학교'},
  {lat: 37.55055556, lng: 126.92583333, name: '홍익대학교'},
  {lat: 37.62425578035092, lng: 127.09887768194511, name: '육군사관학교'},
  {lat: 37.586633, lng: 127.097814, name: '서일대학교'},
  {lat: 37.631399, lng: 127.054808, name: '인덕대학교'},
  {lat: 37.57919703693214, lng: 126.96625245898446, name: '배화여자대학교'},
  {lat: 37.597522560728414, lng: 126.94744860862745, name: '서울여자간호대학교'},
  {lat: 37.557067799999984, lng: 126.98737433276501, name: '숭의여자대학교'},
  {lat: 37.5581375000017, lng: 127.0497555327652, name: '한양여자대학교'}
]

export default collages
